import { Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { authenticationGuard } from './services/authentication/authentication.guard';
import { AfRoutes } from './routes';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { ConfirmResetPasswordComponent } from './authentication/confirm-reset-password/confirm-reset-password.component';
import { customerManagerGuard } from './services/authorization/customer-manager.guard';
import { SetupTotpMfaComponent } from './authentication/setup-totp-mfa/setup-totp-mfa.component';
import { ConfirmTotpMfaComponent } from './authentication/confirm-totp-mfa/confirm-totp-mfa.component';
import { mfaGuard } from './services/authentication/mfa.guard';
import { SetPasswordComponent } from './authentication/set-password/set-password.component';
import { DiagnosticsComponent } from './diagnostics/diagnostics.component';
import { AuthCallbackComponent } from './authentication/auth-callback/auth-callback.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { cpAdminGuard } from './services/authorization/cp-admin.guard';
import { adminGuard } from './services/authorization/admin.guard';
import {ApplicationFrameComponent} from './application-frame/application-frame.component';
import { cbpGuard } from './services/authorization/cbp.guard';
import { faiGuard } from './services/authorization/fai.guard';
import { aclsGuard } from './services/authorization/acls.guard';
import { LogoutComponent } from './authentication/logout/logout.component';
import { SignOutComponent } from './authentication/signout/signout.component';
import { CloudLicenseServerDashboardComponent } from './cloud-license-server/cloud-license-server-dashboard/cloud-license-server-dashboard.component';
import { loginRedirectGuard } from './services/authentication/login-redirect.guard';

export const routes: Routes = [
  {
    path: 'oauth2/authorize',
    pathMatch: 'full',
    redirectTo: AfRoutes.login,
  },
  {
    path: AfRoutes.login,
    component: LoginComponent,
    canActivate: [loginRedirectGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AfRoutes.login,
  },
  {
    path: '',
    component: ApplicationFrameComponent,
    children: [
      {
        path: AfRoutes.authCallback,
        component: AuthCallbackComponent,
      },
      {
        path: AfRoutes.signOut,
        component: SignOutComponent,
        canMatch: [authenticationGuard(AfRoutes.logout)],
      },
      {
        path: AfRoutes.logout,
        component: LogoutComponent,
      },
      {
        path: AfRoutes.diagnostics,
        component: DiagnosticsComponent,
      },
      {
        path: AfRoutes.confirmSignIn,
        component: SetPasswordComponent,
      },
      {
        path: AfRoutes.changePassword,
        component: SetPasswordComponent,
      },
      {
        path: AfRoutes.forgotPassword,
        component: ResetPasswordComponent,
      },
      {
        path: AfRoutes.confirmResetPassword,
        component: ConfirmResetPasswordComponent,
      },
      {
        path: AfRoutes.confirmTotpMfa,
        component: ConfirmTotpMfaComponent,
      },
      {
        path: AfRoutes.welcomePage,
        component: WelcomeComponent,
        canMatch: [authenticationGuard(), mfaGuard()],
      },
      {
        path: AfRoutes.setupTotpMfa,
        component: SetupTotpMfaComponent,
        canMatch: [authenticationGuard()],
      },
      {
        path: AfRoutes.customersDashboard,
        canMatch: [authenticationGuard(), customerManagerGuard(), mfaGuard()],
        loadChildren: () =>
            import('./customers/customers.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: AfRoutes.companyAdminDashboard,
        canMatch: [authenticationGuard(), cpAdminGuard(), mfaGuard()],
        loadChildren: () =>
            import('./company-admin/company-admin.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: AfRoutes.cloudApplicationAdminDashboard,
        canMatch: [authenticationGuard(), cpAdminGuard(), mfaGuard()],
        loadChildren: () =>
            import('./cloud-applications-admin/cloud-application-admin.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: AfRoutes.cloudApplicationDashboard,
        canMatch: [authenticationGuard(), mfaGuard()],
        loadChildren: () =>
            import('./cloud-applications/cloud-application.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: AfRoutes.cloudLicenseServerDashboard,
        canMatch: [authenticationGuard(), aclsGuard(), mfaGuard()],
        component: CloudLicenseServerDashboardComponent,
      },
      {
        path: AfRoutes.settingsDashboard,
        canMatch: [authenticationGuard(), adminGuard(), mfaGuard()],
        loadChildren: () =>
            import('./settings/settings.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: AfRoutes.carBodyPlannerDashboard,
        canMatch: [authenticationGuard(), cbpGuard(), mfaGuard()],
        loadChildren: () =>
            import('./car-body-planner/car-body-planner.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: AfRoutes.feasibilityAiDashboard,
        canMatch: [authenticationGuard(), faiGuard(), mfaGuard()],
        loadChildren: () =>
            import('./feasibility-ai/feasibility-ai.routes').then(
                (feature) => feature.routes
            ),
      },
      {
        path: '**',
        component: NotFoundPageComponent,
      },
    ]
  },
];
